import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DeleteConfirmComponent } from './delete-confirm.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [CommonModule, FormsModule, SharedModule],
    declarations: [DeleteConfirmComponent],
    exports: [DeleteConfirmComponent]
})

export class DeleteConfirmModule { }
